import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { environment } from '../../environments/environment';
import { Events, LoadingController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment';
declare var instituicaoConstants;

@Injectable()
export class UserProvider {
  public linguagem: string = instituicaoConstants.LINGUAGEM ? instituicaoConstants.LINGUAGEM : 'pt';
  baseUrl = environment.API_URL;
  loggedUser = null;
  baseAntigaUrl = environment.API_ANTIGA_URL;
  idInstituicao = null;
  constructor(
    public http: HttpClient,
    private storage: Storage,
    public events: Events,
    public translate: TranslateService,
    private loadingCtrl: LoadingController,
  ) {
    this.getDados().then((res) => {
      if (res) {
        this.loggedUser = res;
        //necessário buscar novamente
        this.atualizarDadosPessoa().subscribe(() => {});
      }
    });
  }

  getPrivacidade(idInstituicao) {
    return this.http
      .get<any>(this.baseUrl + '/privacidade', {
        params: { idInstituicao: idInstituicao },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getTermoUso(idInstituicao) {
    return this.http
      .get<any>(this.baseUrl + '/privacidade/termo-uso', {
        params: { idInstituicao: idInstituicao },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getDados(): Promise<any> {
    return this.storage.get('usuario');
  }

  getDadosInstituicao(): Promise<any> {
    return this.storage.get('instituicao');
  }

  getVersion() {
    return this.storage.get('version');
  }

  hasFacebook() {
    return this.http.get<any>(this.baseUrl + '/pessoa/has-facebook').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getInstituicaoByToken(token) {
    return this.http
      .get<any>(this.baseUrl + '/cadastro/instituicao-by-token', {
        params: { t: token },
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  hasFacebookByKey(key) {
    return this.http.post<any>(this.baseUrl + '/cadastro/has-facebook-by-id', { key: key }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  desvincularFacebook() {
    return this.http.get<any>(this.baseUrl + '/pessoa/desvincular-facebook').map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  vincularFacebook(facebook) {
    return this.http.post<any>(this.baseUrl + '/pessoa/vincular-facebook', facebook).map((data) => {
      return data;
    });
  }

  getIdioma() {
    return this.storage.get('idioma').then((data) => {
      if (!data) {
        this.translate.setDefaultLang(this.linguagem);
        this.setIdioma(this.linguagem);
      } else {
        this.translate.setDefaultLang(data);
        this.setIdioma(data);
      }
    });
  }

  setIdioma(idioma) {
    this.storage.set('idioma', idioma);
    moment.locale(idioma);

    this.translate.setDefaultLang('pt');
    this.translate.use(idioma);

    return true;
  }

  getPrimeiroAcesso() {
    return this.storage.get('acesso');
  }

  setPrimeiroAcesso(acesso) {
    this.storage.set('acesso', acesso);
    return true;
  }

  setTokenPush(pushToken, pushTokenType, version, idInstituicao) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa/push-notification', {
        pushToken: pushToken,
        pushTokenType: pushTokenType,
        pushPlatformVersion: '10.3',
        appVersion: version,
        idInstituicao: idInstituicao,
      })
      .map((data) => {
        if (!data.error) {
          this.storage.set('tokenpush', pushToken);
          return data;
        } else {
          return false;
        }
      });
  }

  setVersion(version) {
    this.storage.set('version', version);
    return true;
  }

  getUserByToken(token) {
    return this.http.post<any>(this.baseUrl + '/login/get-user-by-token', { token: token }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  /**
   * Realiza o cadastro através do token
   */
  public loginByToken(token) {
    return this.http
      .post<any>(this.baseUrl + '/login/user-by-token', {
        token: token,
      })
      .map((data) => {
        if (!data.error) {
          let user = data.user;
          user.instituicao = data.instituicao;
          user.config = data.config;
          this.storage.set('token', data.user.apiKey);
          this.storage.set('user', data.user);
          this.storage.set('instituicao', data.instituicao);
          this.storage.set('config', data.config);
          this.storage.set('usuario', user);
          this.loggedUser = user;
          this.events.publish('user:login', user);
          this.http
            .get('assets/info/info.json')
            .map((res) => <any>res)
            .subscribe((data) => {
              this.getVersion().then((v) => {
                if (!v) {
                  this.setVersion(data.version);
                }
              });
            });
        }
        return data;
      });
  }

  getToken() {
    return this.loggedUser.apiKey;
  }

  getTokenInstituicao() {
    return this.loggedUser.instituicao.apiToken;
  }

  getTokenPush() {
    return this.storage.get('tokenpush');
  }

  validaSenha(usuario) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa/valida-senha', usuario, {
        observe: 'response',
      })
      .map((data) => {
        if (!data.body.error) {
          let user = data.body.user;
          this.storage.set('user', data.body.user);
          this.storage.set('usuario', user);
          this.events.publish('user:login', user);
        }
        return data.body;
      });
  }

  public login(usuario) {
    return this.http.post<any>(this.baseUrl + '/login/user', usuario, { observe: 'response' }).map((data) => {
      if (!data.body.error) {
        let user = data.body.user;
        user.instituicao = data.body.instituicao;
        user.config = data.body.config;
        this.storage.set('token', data.body.user.apiKey);
        this.storage.set('user', data.body.user);
        this.storage.set('instituicao', data.body.instituicao);
        this.storage.set('config', data.body.config);
        this.storage.set('usuario', user);
        this.storage.set('inativa', data.body.status);
        this.loggedUser = user;
        this.events.publish('user:login', user);
        this.http
          .get('assets/info/info.json')
          .map((res) => <any>res)
          .subscribe((data) => {
            this.getVersion().then((v) => {
              if (!v) {
                this.setVersion(data.version);
              }
            });
          });
      }
      return data.body;
    });
  }

  public logout() {
    return new Promise((resolve, reject) => {
      this.storage.remove('token').then((d) => {
        this.storage.remove('tokenpush');
        this.storage.remove('user');
        this.storage.remove('instituicao');
        this.storage.remove('config');
        this.storage.remove('usuario');
      });
      resolve(true);
    });
  }

  public hasConfig(conf) {
    if (this.loggedUser && this.loggedUser.instituicao.configPortalAplicativo[conf]) return true;
    return false;
  }

  public hasPermissao(perm) {
    if (this.loggedUser && this.loggedUser.perm[perm]) return true;

    return false;
  }

  public isLider() {
    if (this.loggedUser) return this.loggedUser.lider;
    return false;
  }

  public isAdmOracao() {
    if (this.loggedUser) return this.loggedUser.admOracao;
    return false;
  }

  public isAdmEscala() {
    if (this.loggedUser) return this.loggedUser.admEscala;
    return false;
  }

  public hasBiblia() {
    if (this.loggedUser && this.loggedUser.instituicao.biblia && this.loggedUser.instituicao.biblia.apiKey)
      return this.loggedUser.instituicao.biblia.apiKey;

    return false;
  }

  public isAnonimo() {
    if (this.loggedUser) {
      return this.loggedUser.isAnonimo;
    }
    return false;
  }

  public isLoggedin() {
    return this.getDados().then((res) => {
      if (res) {
        return true;
      } else {
        return false;
      }
    });
  }

  public validarCodigoIgreja(codigo) {
    return this.http.post<any>(this.baseUrl + '/cadastro/valida-codigo', { codigo: codigo }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  public alterarSenha(senhaatual, senha) {
    return this.http
      .post<any>(this.baseUrl + '/cadastro/alterar-senha', {
        senhaatual: senhaatual,
        senha: senha,
        login: this.loggedUser.login,
      })
      .map((data) => {
        return data;
      });
  }

  public hasAceite(token) {
    return this.http.post<any>(this.baseUrl + '/pessoa/has-aceite', { token: token }).map((data) => {
      return data;
    });
  }

  public getAceiteDescricao() {
    return this.http.get<any>(this.baseUrl + '/pessoa/get-aceite-descricao-novo').map((data) => {
      return data;
    });
  }

  public realizarAceite(tokenpush) {
    return this.http
      .post<any>(this.baseUrl + '/pessoa/realizar-aceite', {
        tokenpush: tokenpush,
      })
      .map((data) => {
        return data;
      });
  }

  public getIgrejasFilhas(idInstituicao, filtro) {
    return this.http
      .post<any>(this.baseUrl + '/cadastro/lista-instituicoes', {
        idInstituicao: idInstituicao,
        filtro: filtro,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  public cadastrarPessoa(pessoa) {
    return this.http.post<any>(this.baseUrl + '/cadastro/cadastrar', pessoa).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return data;
      }
    });
  }

  public tipoSugerido(idInstituicao) {
    return this.http
      .post<any>(this.baseUrl + '/cadastro/lista-tipo-sugerido', {
        idInstituicao: idInstituicao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return data;
        }
      });
  }

  public contribuicoes() {
    let loader: any = this.loadingCtrl.create({
      content: this.translate.instant('Carregando'),
    });
    loader.present();
    return this.http
      .get<any>(this.baseUrl + '/pessoa/contribuicoes')
      .pipe(finalize(() => loader.dismiss()))
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return data;
        }
      });
  }

  public contribuicoesDetalhes(idPessoa, idPlanoContas) {
    let loader: any = this.loadingCtrl.create({
      content: this.translate.instant('Carregando'),
    });
    loader.present();
    return this.http
      .post<any>(this.baseUrl + '/pessoa/contribuicoes-detalhes', {
        idPessoa: idPessoa,
        idPlanoContas: idPlanoContas,
      })
      .pipe(finalize(() => loader.dismiss()))
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return data;
        }
      });
  }

  public esconderCadastro(idInstituicao) {
    return this.http
      .post<any>(this.baseUrl + '/login/esconder-cadastro', {
        idInstituicao: idInstituicao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return data;
        }
      });
  }

  public esconderFB(idInstituicao) {
    return this.http
      .post<any>(this.baseUrl + '/login/esconder-cadastrofb', {
        idInstituicao: idInstituicao,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return data;
        }
      });
  }

  public esconderFBProver() {
    return this.http.post<any>(this.baseUrl + '/login/fb-prover', {}).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return data;
      }
    });
  }

  public atualizarDadosPessoa() {
    return this.http
      .get<any>(this.baseUrl + '/pessoa', {
        params: { version: environment.APP_VERSION },
      })
      .map((data) => {
        if (!data.error) {
          let user = data.user;
          user.instituicao = data.instituicao;
          user.config = data.config;

          this.storage.set('config', data.config);
          this.storage.set('instituicao', data.instituicao);
          this.storage.set('usuario', user);
          this.storage.set('inativa', data.status);

          this.loggedUser = user;
          this.events.publish('user:login', user);

          return data;
        } else {
          return false;
        }
      });
  }

  // public getLinksSystem(array) {
  //   let links = '';
  //   if (array) {
  //     links = array.join(',');
  //   }

  //   return this.http.get<any>(this.baseUrl + '/pessoa/get-links-system', { params: { links: links } }).map((data) => {
  //     if (!data.error) {
  //       return data;
  //     } else {
  //       return false;
  //     }
  //   });

  // }
}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts